// Mirrors backend Billing::ItemizedTaxCalculation
// See app/models/billing/itemized_tax_calculation.rb:16
export const calculateItemizedTaxTotal = (amountInCents, taxes) => {
  if (!taxes || taxes.length === 0) return 0

  return taxes.reduce((totalTax, tax) => {
    const taxAmount = Math.round(amountInCents * tax.rate)
    return totalTax + taxAmount
  }, 0)
}

// Calculate individual tax amounts for each tax
// Mirrors backend Billing::ItemizedTaxCalculation#itemized_taxes
// See app/models/billing/itemized_tax_calculation.rb
export const calculateIndividualTaxAmounts = (amountInCents, taxes) => {
  if (!taxes || taxes.length === 0) return []

  return taxes.map((tax) => ({
    ...tax,
    amount: Math.round(amountInCents * tax.rate),
  }))
}
